import { render, staticRenderFns } from "./processEdit.vue?vue&type=template&id=51492a16&scoped=true&lang=pug"
import script from "./processEdit.vue?vue&type=script&lang=js"
export * from "./processEdit.vue?vue&type=script&lang=js"
import style0 from "./processEdit.vue?vue&type=style&index=0&id=51492a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51492a16",
  null
  
)

export default component.exports